<!-- Hyperpure Cart Iframe - Standalone Page -->
<div class="hyperpure-cart-page">
    <!-- Loading Overlay -->
    <div class="loading-overlay" *ngIf="isLoading">
        <div class="loading-spinner">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            <p class="loading-text">Loading Hyperpure Cart...</p>
        </div>
    </div>

    <!-- Iframe Container -->
    <div class="iframe-container" *ngIf="showIframe">
        <iframe #iframeElement
            *ngIf="iframeUrlSafe"
            [src]="iframeUrlSafe"
            class="hyperpure-iframe"
            frameborder="0"
            loading="lazy"
            allow="payment; geolocation"
            title="Hyperpure Cart"
        ></iframe>

        <!-- Iframe Loading Indicator -->
        <div class="iframe-loading" *ngIf="isLoading">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading iframe...</span>
            </div>
        </div>
    </div>

    <!-- Error State -->
    <div class="error-container" *ngIf="!showIframe && !isLoading">
        <div class="error-content">
            <i class="material-icons error-icon">error_outline</i>
            <h2>Unable to Load Hyperpure Cart</h2>
            <p>Please ensure you have valid authentication credentials.</p>
            <button class="btn btn-primary" (click)="closeIframe()">
                Go Back to Purchase Manager
            </button>
        </div>
    </div>
</div>


